<app-select (ngModelChange)="changeEntities($event)" [ngModel]="rule.value" multiple>
  @for (opt of options; track opt) {
    <mat-option [value]="opt.value">
      {{ opt.name }}
    </mat-option>
  }
</app-select>
